import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { AmendBookingData, getAmendData } from 'src/api/amendService';

export const useGetAmendData = (vitaRef: string) => {
    const hasVitaRef = vitaRef !== null && vitaRef.length > 0;
    const userLoggedIn = useSelector(selectUserLoggedIn);

    const query = useQuery<AmendBookingData, AxiosError, AmendBookingData>({
        enabled: userLoggedIn && hasVitaRef,
        queryKey: ['amend', vitaRef],
        queryFn: async () => getAmendData(vitaRef as string),
    });

    return {
        ...query,
    };
};
